import React, { useCallback, useEffect, useRef, useState } from "react";
import { StudentProfileMapContainer } from "./StudentProfileMapStyled";
import { EsriProvider } from "leaflet-geosearch";

import L from "leaflet";

import { MapContainer, TileLayer, Marker } from "react-leaflet";

import "leaflet/dist/leaflet.css";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

import StudentProfileService, { IStudentApiResponse } from "../../../services/student.profile.service";

const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

export interface Props {
    lat: number | null;
    lng: number | null;
    zoom?: number;
    address?: string;
    editing?: boolean;
    editable?: boolean;
    studentData?: {
        name: string;
        id: number;
    };
}

const StudentProfileMapWrapper: React.FC<Props> = ({ ...props }: Props) => {
    const [coords, setCoords] = useState({
        lat: props.lat || -23.5505, // Default to São Paulo
        long: props.lng || -46.6333,
    });
    const [address, setAddress] = useState(props.address || "");
    const [editing, setEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const markerRef = useRef(null);

    const getCoordinates = useCallback(async () => {
        if (props.lat !== null && props.lng !== null) {
            // Use provided coordinates
            setCoords({
                lat: props.lat,
                long: props.lng,
            });
        } else if (address && address.trim()) {
            // Search by address
            setIsLoading(true);
            try {
                const esriProvider = new EsriProvider();
                const response = await esriProvider.search({
                    query: address.trim(),
                });

                if (response.length) {
                    const result = response[0];
                    setCoords({
                        lat: parseFloat(result.y.toString()),
                        long: parseFloat(result.x.toString()),
                    });
                }
            } catch (error) {
                console.error("Erro ao buscar localização: ", error);
            } finally {
                setIsLoading(false);
            }
        }
    }, [address, props.lat, props.lng]);

    const setNewCoordinates = useCallback(async (e: L.DragEndEvent) => {
        const newLat = e.target.getLatLng().lat;
        const newLng = e.target.getLatLng().lng;

        setCoords({
            lat: newLat,
            long: newLng,
        });

        try {
            const studentProfileService = new StudentProfileService();
            const aluno = await studentProfileService.list();

            if (aluno.nome) {
                await studentProfileService.update(
                    aluno.id,
                    {
                        nome: aluno.nome,
                        ltd: newLat,
                        lng: newLng,
                    },
                    true // isUser
                );
            }
        } catch (error) {
            console.error("Erro ao atualizar coordenadas:", error);
        }
    }, []);

    // const logLatLong = useCallback(() => {
    // 	console.log("LOG LATLONG", coords);
    // }, [coords]);

    //const editMap = useCallback(async () => {}, []);

    useEffect(() => {
        setAddress(props.address || "");
    }, [props.address]);

    useEffect(() => {
        getCoordinates();
    }, [getCoordinates]);

    // Don't render map with invalid coordinates
    if (!coords.lat || !coords.long) {
        return (
            <StudentProfileMapContainer {...props}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
                    {isLoading ? "Carregando mapa..." : "Coordenadas inválidas"}
                </div>
            </StudentProfileMapContainer>
        );
    }

    return (
        <StudentProfileMapContainer {...props}>
            {props.editable && (
                <button className="editPill" onClick={() => setEditing(!editing)}>
                    {editing ? "Salvar Mapa" : "Editar"}
                </button>
            )}
            <MapContainer key={`${coords.lat}-${coords.long}`} center={[coords.lat, coords.long]} zoom={props.zoom || 15} scrollWheelZoom={true}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker ref={markerRef} position={[coords.lat, coords.long]} draggable={editing} eventHandlers={{ dragend: setNewCoordinates }} />
            </MapContainer>
        </StudentProfileMapContainer>
    );
};

export { StudentProfileMapWrapper as StudentProfileMap };
